import axios, { AxiosResponse } from "axios";
import { article } from "components/articles/ArticleInterfaces";
import { SetStateAction } from "react";
import { HOST } from "./constants";

// Tipo reutilizable para setState
type SetArticles = (value: SetStateAction<article[]>) => void;

// Obtener artículos activos
export const getArticleList = (setArticleData: SetArticles) => {
  return axios
    .get(`${HOST}/catalogmx/index.php/article/features`)
    .then((response) => setArticleData(response.data))
    .catch((error) => console.error(error));
};

// Obtener artículos inactivos
export const getInactiveArticleList = (setArticleData: SetArticles) => {
  return axios
    .get(`${HOST}/catalogmx/index.php/article/features?inactive=1`)
    .then((response) => setArticleData(response.data))
    .catch((error) => console.error(error));
};

// Cambiar estatus activo/inactivo de un artículo
export const changeArticleStatus = (id: number, active: boolean): Promise<AxiosResponse> => {
  return axios({
    method: "delete",
    url: `${HOST}/catalogmx/index.php/article/features`,
    headers: { "Content-Type": "application/json" },
    data: { id, active },
  })
    .then((response) => {
      console.info(response);
      return response;
    })
    .catch((error) => {
      console.error(error);
      throw error;
    });
};

// Obtener un artículo por ID
export const getArticleDetails = (setArticleData: SetArticles, articleId: string) => {
  return axios
    .get(`${HOST}/catalogmx/index.php/article/features?id=${articleId}`)
    .then((response) => setArticleData(response.data))
    .catch((error) => console.error(error));
};

// Guardar o actualizar artículo
export const saveArticle = (input: article): Promise<AxiosResponse<{ status: string }>> => {
  return axios({
    method: "post",
    url: `${HOST}/catalogmx/index.php/article/features`,
    headers: { "Content-Type": "application/json" },
    data: input,
  });
};
